import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const QuemSomosPage = lazy(() => import('../pages/quem-somos/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const LimpezaProfissionalPage = lazy(() => import('../pages/servicos/limpeza-profissional/page'));
const TratamentoProfissionalPage = lazy(() => import('../pages/servicos/tratamento-profissional/page'));
const TrocaRejuntePage = lazy(() => import('../pages/servicos/troca-rejunte/page'));
const PolimentoPage = lazy(() => import('../pages/servicos/polimento/page'));
const ImpermeabilizacaoPage = lazy(() => import('../pages/servicos/impermeabilizacao/page'));
const RestauracaoPage = lazy(() => import('../pages/servicos/restauracao/page'));
const TratamentoLaminadoPage = lazy(() => import('../pages/servicos/tratamento-laminado/page'));
const PoliticaPrivacidadePage = lazy(() => import('../pages/politica-privacidade/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quem-somos',
    element: <QuemSomosPage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/servicos/limpeza-profissional',
    element: <LimpezaProfissionalPage />,
  },
  {
    path: '/servicos/tratamento-profissional',
    element: <TratamentoProfissionalPage />,
  },
  {
    path: '/servicos/troca-rejunte',
    element: <TrocaRejuntePage />,
  },
  {
    path: '/servicos/polimento',
    element: <PolimentoPage />,
  },
  {
    path: '/servicos/impermeabilizacao',
    element: <ImpermeabilizacaoPage />,
  },
  {
    path: '/servicos/restauracaoerevitalizacao',
    element: <RestauracaoPage />,
  },
  {
    path: '/servicos/tratamento-laminado',
    element: <TratamentoLaminadoPage />,
  },
  {
    path: '/politica-privacidade',
    element: <PoliticaPrivacidadePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
